module.exports = __webpack_public_path__ + "img/product-reviews-04.1474184b.png";